
import { ContractItem } from './contract-item';

import { Entity } from '../base/entity';

export class Contract extends Entity {

    public static readonly TABLENAME = 'contract';

    public static readonly ID = 'id';
    public static readonly PARTNER_ID = 'partner_id';
    public static readonly NABAVKA_PARTIJA_ID = 'nabavka_partija_id';
    public static readonly CONTRACT_NUMBER = 'contract_number';
    public static readonly DATE_FROM = 'date_from';
    public static readonly DATE_TO = 'date_to';
    public static readonly PARENT_CONTRACT_ID = 'parent_contract_id';
    public static readonly DESCRIPTION = 'description';
    public static readonly REFERENCE_NUMBER = 'reference_number';
    public static readonly REFERENCE_DATE = 'reference_date';
    public static readonly DEADLINE_INVOICING = 'deadline_invoicing';
    public static readonly DELINE_PAYMENT = 'deline_payment';
    public static readonly CASH_DISCOUNT_PERCENT = 'cash_discount_percent';
    public static readonly CASH_DISCOUNT_DEADLINE = 'cash_discount_deadline';
    public static readonly COMMENT = 'comment';
    public static readonly STATUS = 'status';
    public static readonly CURRENCY_ID = 'currency_id';
    public static readonly STOCKROOM_ID = 'stockroom_id';
    public static readonly COMPANY_ID = 'company_id';
    public static readonly CREATED_AT = 'created_at';
    public static readonly UPDATED_AT = 'updated_at';
    public static readonly DELETED_AT = 'deleted_at';
    public static readonly APP_USER_ID = 'app_user_id';
    public static readonly CONTRACT_TYPE_ID = 'contract_type_id';
    public static readonly PATH = 'path';

    contractItems: ContractItem[];

    id: string;
    partnerId: string;
    nabavkaPartijaId: string;
    contractNumber: string;
    dateFrom: Date;
    dateTo: Date;
    parentContractId: string;
    description: string;
    referenceNumber: string;
    referenceDate: Date;
    deadlineInvoicing: number;
    delinePayment: number;
    cashDiscountPercent: number;
    cashDiscountDeadline: number;
    comment: string;
    status: string;
    currencyId: string;
    stockroomId: string;
    companyId: string;
    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date;
    appUserId: number;
    contractTypeId: number;
    path: string;
    brnabavke: string;
    predmetId: string;
}
